import React from 'react'

/**
 * Hook to get dimensions of media files (images and videos)
 */
export const useMediaDimensions = () => {
  const [isLoading, setIsLoading] = React.useState(false)

  const getMediaDimensions = (
    file: File,
  ): Promise<{ width: number; height: number }> => {
    setIsLoading(true)
    return new Promise((resolve) => {
      // Default dimensions if not an image or video
      const defaultDimensions = { width: 0, height: 0 }

      // Handle image files
      if (file.type.startsWith('image/')) {
        const img = new Image()
        img.onload = () => {
          setIsLoading(false)
          resolve({
            width: img.width,
            height: img.height,
          })
          URL.revokeObjectURL(img.src) // Clean up
        }
        img.onerror = () => {
          setIsLoading(false)
          resolve(defaultDimensions)
        }
        img.src = URL.createObjectURL(file)
        return
      }

      // Handle video files
      if (file.type.startsWith('video/')) {
        const video = document.createElement('video')
        video.onloadedmetadata = () => {
          setIsLoading(false)
          resolve({
            width: video.videoWidth,
            height: video.videoHeight,
          })
          URL.revokeObjectURL(video.src) // Clean up
        }
        video.onerror = () => {
          setIsLoading(false)
          resolve(defaultDimensions)
        }
        video.src = URL.createObjectURL(file)
        return
      }

      setIsLoading(false)
      resolve(defaultDimensions)
    })
  }

  return {
    getMediaDimensions,
    isLoading,
  }
}
